import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

// Pfad zum Logo
import logoImage from '../assets/portalLogo.png';

interface LogoProps {
  width?: number | string;
  height?: number | string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  alt?: string;
}

/**
 * Logo-Komponente für die Anwendung
 * 
 * @param width - Breite des Logos (default: 'auto')
 * @param height - Höhe des Logos (default: 40)
 * @param sx - Zusätzliche Styling-Eigenschaften
 * @param onClick - Optional Click-Handler
 * @param alt - Alt-Text für das Bild (default: 'Logo')
 */
const Logo: React.FC<LogoProps> = ({ 
  width = 'auto', 
  height = 64, 
  sx = {}, 
  onClick,
  alt = 'Logo'
}) => {
  return (
    <Box
      component="img"
      src={logoImage}
      alt={alt}
      sx={{
        width,
        height,
        cursor: onClick ? 'pointer' : 'default',
        ...sx
      }}
      onClick={onClick}
    />
  );
};

export default Logo;